import log from 'loglevel'

const prod = {
    url: {
        API_URL: window.location.origin,
        MERCURE_URL: `${window.location.origin}/mercure`,
    },
    logLevel: log.levels.WARN,
}

const dev = {
    url: {
        API_URL: ['localhost', '127.0.0.1'].includes(window.location.hostname) ? 'http://localhost:8085' : window.location.origin,
        MERCURE_URL: `${window.location.origin}/mercure`,
    },
    logLevel: log.levels.DEBUG,
}

const config = process.env.NODE_ENV === 'development' ? dev : prod;

export default config
